import developer from '@docs/developer-guide.md?raw'
import expert from '@docs/sme-guide.md?raw'
import workflow from '@docs/workflow.md?raw'
import architecture from '@docs/architecture.md?raw'
import crossReview from '@docs/cross-review.md?raw'
import api from '@docs/api.md?raw'
import data from '@docs/data-model.md?raw'

// Only maintained platform documentation belongs in the app. Preview plans, incident
// reports and repository instructions remain in Git, outside the production bundle.
export const DOCUMENTS = [
  { name: 'developer-guide.md', title: 'Developer guide', body: developer },
  { name: 'sme-guide.md', title: 'Expert guide', body: expert },
  { name: 'workflow.md', title: 'Task workflow', body: workflow },
  { name: 'architecture.md', title: 'Architecture', body: architecture },
  { name: 'cross-review.md', title: 'Cross-review architecture', body: crossReview },
  { name: 'api.md', title: 'API reference', body: api },
  { name: 'data-model.md', title: 'Data model', body: data },
]
